export const accessorialColumns = [
  {
    label: "  Accessorials",
    field: "description",
    minWidth: 80
  },
  {
    label: "charge",
    field: "total",
    minWidth: 60
  },
  {
    label: "Notes",
    field: "notes",
    minWidth: 100
  },
];

export const accessorialsQuoteDrayage = {
  lineHaul: "Line Haul",
  fuelSurcharge: "Fuel Surcharge",
  totalChsRental: "Chassis Rental",
  chsPickup: "Chassis Split",
  chsPickupFsc: "Chassis Split Fsc",
  chsReturn: "Chassis Return",
  chsReturnFsc: "Chassis Return Fsc",
  hazardous: "Hazmat",
  layover: "Layover",
  overweight: "Overweight",
  prepull: "Prepull",
  reefer: "Reefer",
};

export const priceQuoteDrayage = {
  price: "Total Price",
};

export const HazardousOptions = [
  { label: "2.1", value: "2.1" },
  { label: "2.2", value: "2.2" },
  { label: "3", value: "3" },
  { label: "4.1", value: "4.1" },
  { label: "4.2", value: "4.2" },
  { label: "4.3", value: "4.3" },
  { label: "5.1", value: "5.1" },
  { label: "5.2", value: "5.2" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
];

export function isOverweight(accessorials) {
  return accessorials.some((acc) => acc.name.toLowerCase() === "overweight");
}
export function getMaxWeightByContainerType(typeContainer) {
  switch (parseInt(typeContainer, 10)) {
    case 20:
      return '38000';
    case 40:
    case 45:
      return '44000';
    default:
      return null;
  }
}
